import { toast } from '../core/toast.js';
import { icon } from '../core/icons.js';
import { confirmModal } from '../core/modal.js';
import { btEraseData, btProcess } from '../core/bt.js';

/**
 * Bulk-action toolbar — slides in when ≥1 row is selected.
 */
export class Toolbar {
  constructor({ selection, onAction }) {
    this.selection = selection;
    this.onAction = onAction;
    this.el = document.getElementById('toolbar');
    this.countEl = document.getElementById('tb-count');
    if (!this.el) return;

    this.el.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-bulk]');
      if (!btn) return;
      this._dispatch(btn.dataset.bulk);
    });
  }

  refresh() {
    if (!this.el) return;
    const n = this.selection.size();
    if (n === 0) {
      this.el.classList.add('is-hidden');
    } else {
      this.el.classList.remove('is-hidden');
      if (this.countEl) this.countEl.textContent = n;
    }
  }

  async _dispatch(action) {
    if (action === 'clear') {
      this.selection.clear();
      document.querySelectorAll('.row__check:checked').forEach((c) => (c.checked = false));
      return;
    }
    const hashes = this.selection.values();
    if (hashes.length === 0) return;
    if (
      action === 'delete' &&
      !(await confirmModal({
        title: `${hashes.length} Torrents und Daten löschen`,
        message: 'Alle ausgewählten Torrents und ihre Dateien werden unwiderruflich gelöscht.',
        confirmLabel: 'Torrents + Daten löschen',
        danger: true,
      }))
    )
      return;

    toast.info(`Queueing ${hashes.length}…`);

    const flipToRemoving = (row) => {
      if (!row) return;
      row.classList.add('is-removing');
      const actions = row.querySelector('.row__actions');
      if (actions) {
        actions.innerHTML = `<span class="chip chip--danger"><span class="spin">${icon('loader', { size: 12 })}</span>erasing</span>`;
      }
    };

    let ok = 0;
    let failed = 0;
    for (const hash of hashes) {
      try {
        if (action === 'delete') await btEraseData(hash);
        else if (action === 'zap') await btProcess(hash);
        else throw new Error(`Unbekannte Bulk-Aktion: ${action}`);
        if (action === 'delete') {
          flipToRemoving(document.getElementById('row-' + hash));
        }
        ok++;
      } catch {
        failed++;
      }
    }
    if (failed) toast.error(`${ok} erfolgreich, ${failed} fehlgeschlagen`);
    else toast.success(`${ok} ${action} eingereiht`);
    this.selection.clear();
    document.querySelectorAll('.row__check:checked').forEach((c) => (c.checked = false));
    this.onAction?.();
  }
}
